import { render, staticRenderFns } from "./h2-block.vue?vue&type=template&id=3d07ba3a&"
import script from "./h2-block.vue?vue&type=script&lang=js&"
export * from "./h2-block.vue?vue&type=script&lang=js&"
import style0 from "./h2-block.vue?vue&type=style&index=0&id=3d07ba3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports